/* Dagrox — quick-add.js (30/09/2026)
   "+" sulle card dei prodotti con varianti: apre la scelta rapida (snippets/quick-add.liquid) con opzioni, foto e prezzo
   della variante. "Aggiungi al carrello" porta l'id della variante in [data-add-variant-id]: l'aggiunta al carrello e
   l'apertura del carrello laterale le fa cart-drawer.js, come per i prodotti a variante unica.
   Se il prodotto non si carica, il "+" resta un link alla pagina prodotto.
*/
(function () {
  'use strict';

  var panel = document.querySelector('[data-qa]');
  var scrim = document.querySelector('[data-qa-scrim]');
  if (!panel || !scrim) return;

  var el = {
    img: panel.querySelector('[data-qa-img]'),
    title: panel.querySelector('[data-qa-title]'),
    price: panel.querySelector('[data-qa-price]'),
    compare: panel.querySelector('[data-qa-compare]'),
    options: panel.querySelector('[data-qa-options]'),
    add: panel.querySelector('[data-qa-add]'),
    addLabel: panel.querySelector('[data-qa-add-label]'),
    link: panel.querySelector('[data-qa-link]'),
    close: panel.querySelector('[data-qa-close]')
  };
  var addText = el.addLabel ? el.addLabel.textContent.trim() : 'Aggiungi al carrello';
  var moneyFormat = panel.getAttribute('data-money-format') || '€{{amount_with_comma_separator}}';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cache = {};
  var product = null;
  var selected = [];
  var trigger = null;
  var picked = false; // la foto della variante si mostra dopo il primo clic su un'opzione, come nella PDP

  function withSeparators(fixed, thousands, decimal) {
    var parts = fixed.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.length > 1 ? whole + decimal + parts[1] : whole;
  }
  function money(cents) {
    var value = (cents || 0) / 100;
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount': return withSeparators(value.toFixed(2), ',', '.');
        case 'amount_no_decimals': return withSeparators(value.toFixed(0), ',', '.');
        case 'amount_with_comma_separator': return withSeparators(value.toFixed(2), '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withSeparators(value.toFixed(0), '.', ',');
        case 'amount_with_apostrophe_separator': return withSeparators(value.toFixed(2), "'", '.');
        default: return withSeparators(value.toFixed(2), '.', ',');
      }
    });
  }
  function sized(url, width) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function load(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (p) { cache[handle] = p; return p; });
  }

  function currentVariant() {
    if (!product) return null;
    return product.variants.find(function (v) {
      return v.options.every(function (val, i) { return val === selected[i]; });
    }) || null;
  }

  function renderOptions() {
    var html = '';
    product.options.forEach(function (opt, i) {
      var values = opt.values || [];
      if (values.length < 2) return;
      html += '<div class="opt-block" role="group" aria-label="' + escapeHtml(opt.name) + '">'
        + '<span class="label">' + escapeHtml(opt.name) + '</span><div class="opt-row">';
      values.forEach(function (val) {
        html += '<button type="button" class="opt' + (selected[i] === val ? ' selected' : '') + '" data-qa-opt="' + i + '" data-value="' + escapeHtml(val) + '" aria-pressed="' + (selected[i] === val) + '">' + escapeHtml(val) + '</button>';
      });
      html += '</div></div>';
    });
    el.options.innerHTML = html;
  }

  function applyVariant() {
    var v = currentVariant();
    el.options.querySelectorAll('[data-qa-opt]').forEach(function (b) {
      var on = selected[parseInt(b.getAttribute('data-qa-opt'), 10)] === b.getAttribute('data-value');
      b.classList.toggle('selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var imgUrl = (picked && v && v.featured_image && v.featured_image.src) || product.featured_image || '';
    if (imgUrl) {
      var next = sized(imgUrl, 700);
      if (el.img.getAttribute('src') !== next) el.img.setAttribute('src', next);
      el.img.setAttribute('alt', product.title + (v && v.title && v.title !== 'Default Title' ? ' — ' + v.title : ''));
    }
    if (v) {
      el.price.textContent = money(v.price);
      el.compare.textContent = v.compare_at_price && v.compare_at_price > v.price ? money(v.compare_at_price) : '';
    }
    if (v && v.available) {
      el.add.disabled = false;
      el.add.setAttribute('data-add-variant-id', String(v.id));
      el.addLabel.textContent = addText + ' · ' + money(v.price);
    } else {
      el.add.disabled = true;
      el.add.removeAttribute('data-add-variant-id');
      el.addLabel.textContent = v ? 'Esaurito' : 'Combinazione non disponibile';
    }
  }

  function open(handle, from) {
    trigger = from || null;
    if (trigger) trigger.setAttribute('aria-busy', 'true');
    return load(handle).then(function (p) {
      product = p;
      var start = p.variants.find(function (v) { return v.available; }) || p.variants[0];
      selected = start.options.slice();
      picked = false;
      el.title.textContent = p.title;
      el.link.setAttribute('href', p.url || (root + 'products/' + handle));
      renderOptions();
      applyVariant();
      scrim.hidden = false;
      panel.hidden = false;
      document.body.style.overflow = 'hidden';
      panel.scrollTop = 0;
      if (el.close) el.close.focus({ preventScroll: true });
    }).finally(function () {
      if (trigger) trigger.removeAttribute('aria-busy');
    });
  }

  function close() {
    if (panel.hidden) return;
    panel.hidden = true;
    scrim.hidden = true;
    document.body.style.overflow = '';
    if (trigger && document.contains(trigger)) { try { trigger.focus({ preventScroll: true }); } catch (e) {} }
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-quick-add]');
    if (!t) return;
    var handle = t.getAttribute('data-quick-add');
    if (!handle) return;
    e.preventDefault();
    var href = t.getAttribute('href');
    open(handle, t).catch(function () { if (href) window.location.href = href; });
  });

  el.options.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qa-opt]');
    if (!b) return;
    selected[parseInt(b.getAttribute('data-qa-opt'), 10)] = b.getAttribute('data-value');
    picked = true;
    applyVariant();
  });

  // Il clic arriva prima qui (sul bottone) e poi a cart-drawer.js (sul documento), che aggiunge e apre il carrello.
  el.add.addEventListener('click', function () {
    if (el.add.hasAttribute('data-add-variant-id')) close();
  });
  if (el.close) el.close.addEventListener('click', function () { close(); });
  scrim.addEventListener('click', function () { close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();
